import { gql } from '@apollo/client'

export const CANCEL_RESERVATION_TA_PANEL_ROOM_STAY_MUTATION = gql`
  mutation CancelReservationTAPanelRoomStay(
    $dryRun: String!
    $reservationNumber: String!
    $roomReservationNumber: String!
    $cancelReason: String!
    $cancellationPolicyOverridden: Boolean
    $overriddenCancellationPenalty: Float
  ) {
    cancelReservationTAPanelRoomStay(
      dryRun: $dryRun
      reservationNumber: $reservationNumber
      roomReservationNumber: $roomReservationNumber
      cancelReason: $cancelReason
      cancellationPolicyOverridden: $cancellationPolicyOverridden
      overriddenCancellationPenalty: $overriddenCancellationPenalty
    ) {
      CRSNumber
      description
      info {
        currency
        originalAmount
        penalty
        ratePlanCode
        displayRatePlanCode
        roomTypeCode
        displayRoomTypeCode
        roomTypeName
      }
      reservationNumber
      status
    }
  }
`
export const CANCEL_RESERVATION_TA_PANEL_ROOM_STAY_PREVIEW_QUERY = gql`
  query CancelReservationTAPanelRoomStayPreview(
    $reservationNumber: String!
    $roomReservationNumber: String!
  ) {
    cancelReservationTAPanelRoomStayPreview(
      reservationNumber: $reservationNumber
      roomReservationNumber: $roomReservationNumber
    ) {
      roomTypeName
      roomTypeCode
      displayRoomTypeCode
      ratePlanName
      ratePlanCode
      displayRatePlanCode
      guests {
        name
        email
        mobile
      }
      numberOfGuests
      numberOfExtrabeds
      numberOfChildren
      checkIn
      checkOut
      status
      oldPrice
      currentPrice
      currency
      penalty
      payable
    }
  }
`
